export { default as ClassicFormal } from './ClassicFormal';
export { default as ArtisticCollage } from './ArtisticCollage';
export { default as ModernMinimal } from './ModernMinimal';
export { default as TropicalBeach } from './TropicalBeach';
export { default as NoirVinyl } from './NoirVinyl';
export { default as LightVinyl } from './LightVinyl';
export { default as PremiumStory } from './PremiumStory';
export { default as RSVPForm } from './RSVPForm';

// Template configurations for the editor
export const RSVP_TEMPLATES = {
  classic_formal: {
    id: 'classic_formal',
    name: 'Classic Formal',
    description: 'Elegant and timeless design with clean typography',
    thumbnail: '/templates/classic-formal-thumb.jpg',
    defaultColors: {
      primary: '#1a1a1a',
      secondary: '#666666',
      accent: '#d4af37',
      background: '#f5f5f0'
    }
  },
  artistic_collage: {
    id: 'artistic_collage',
    name: 'Artistic Collage',
    description: 'Moody editorial collage with Polaroid-framed photos',
    thumbnail: '/templates/artistic-collage-thumb.jpg',
    defaultColors: {
      primary: '#2c2c2c',
      secondary: '#6b6560',
      accent: '#8b7d6b',
      background: '#e8e4df'
    }
  },
  modern_minimal: {
    id: 'modern_minimal',
    name: 'Modern Minimal',
    description: 'Clean lines, bold typography, lots of white space',
    thumbnail: '/templates/modern-minimal-thumb.jpg',
    defaultColors: {
      primary: '#111111',
      secondary: '#777777',
      accent: '#111111',
      background: '#ffffff'
    }
  },
  tropical_beach: {
    id: 'tropical_beach',
    name: 'Tropical Beach',
    description: 'Warm tones with leaf accents and rounded cards',
    thumbnail: '/templates/tropical-beach-thumb.jpg',
    defaultColors: {
      primary: '#1a3c34',
      secondary: '#5c8a7d',
      accent: '#e8a849',
      background: '#fefaf3'
    }
  },
  noir_vinyl: {
    id: 'noir_vinyl',
    name: 'Noir Vinyl',
    description: 'Dark, cinematic design with album sleeve hero and gold accents',
    thumbnail: '/templates/noir-vinyl-thumb.jpg',
    defaultColors: {
      primary: '#ffffff',
      secondary: '#888888',
      accent: '#d4af37',
      background: '#000000'
    }
  },
  light_vinyl: {
    id: 'light_vinyl',
    name: 'Light Vinyl',
    description: 'Warm, elegant design with cream tones and vinyl player',
    thumbnail: '/templates/light-vinyl-thumb.jpg',
    defaultColors: {
      primary: '#2c2c2c',
      secondary: '#8a8278',
      accent: '#8b7d6b',
      background: '#f2efeb'
    }
  },
  premium_story: {
    id: 'premium_story',
    name: 'Premium Story',
    description: 'Cinematic mobile-first storytelling with countdown, map, FAQ, and floating controls',
    thumbnail: '/templates/premium-story-thumb.jpg',
    defaultColors: {
      primary: '#2c2420',
      secondary: '#8a8278',
      accent: '#c08081',
      background: '#faf8f5'
    }
  }
};

// Color theme presets
export const COLOR_PRESETS = [
  { name: 'Classic Gold', colors: { primary: '#1a1a1a', secondary: '#666666', accent: '#d4af37', background: '#f5f5f0' } },
  { name: 'Rose Garden', colors: { primary: '#2d2d2d', secondary: '#666666', accent: '#c08081', background: '#fdf6f6' } },
  { name: 'Sage Green', colors: { primary: '#2d3830', secondary: '#5c6b5e', accent: '#87a878', background: '#f4f7f4' } },
  { name: 'Navy Elegance', colors: { primary: '#1e3a5f', secondary: '#4a6fa5', accent: '#c9a961', background: '#f8fafc' } },
  { name: 'Burgundy Romance', colors: { primary: '#4a1c2b', secondary: '#7d3c50', accent: '#c9a961', background: '#faf8f8' } },
  { name: 'Modern Minimal', colors: { primary: '#1a1a1a', secondary: '#888888', accent: '#1a1a1a', background: '#ffffff' } },
  { name: 'Midnight', colors: { primary: '#ffffff', secondary: '#a0a0a0', accent: '#d4af37', background: '#1a1a1a' } },
  { name: 'Dusty Blue', colors: { primary: '#2c3e50', secondary: '#7f8c8d', accent: '#6b8cae', background: '#f5f8fa' } },
  { name: 'Tropical Sunset', colors: { primary: '#1a3c34', secondary: '#5c8a7d', accent: '#e8a849', background: '#fefaf3' } },
];

// Font style options
export const FONT_STYLES = [
  { id: 'serif', name: 'Classic Serif', preview: 'Aa' },
  { id: 'sans', name: 'Modern Sans', preview: 'Aa' },
  { id: 'script', name: 'Elegant Script', preview: 'Aa' },
];
